<template>
  <section class="_menu-section-style">
    <form-section label="Organização" v-model="isExpanded.organization">
      <div class="d-flex flex-column" style="gap: 16px">
        <TextField v-model="selectedSection.organization.title" label="Título"/>
        <div>
          <div class="_subtitleFormFont">Logos:</div>
          <MultipleUploadImage v-model="selectedSection.organization.logos" keyValue="image" multiple/> 
        </div>
      </div>
    </form-section> 

    <form-section label="Contatos" v-model="isExpanded.contacts">
      <div class="d-flex flex-column" style="gap: 16px">
        <TextField v-model="selectedSection.contact.title" label="Título"/> 
        <TextField v-model="selectedSection.contact.phone" label="Telefone"/> 
        <TextField v-model="selectedSection.contact.email" label="E-mail"/> 
        <TextField v-model="selectedSection.contact.site" label="Site"/> 
      </div>
    </form-section>  

    <form-section label="Social" v-model="isExpanded.social">
      <div class="d-flex flex-column" style="gap: 16px">
        <v-row no-gutters>
          <v-col cols="6" class="_pr-">
            <TextField v-model="selectedSection.social.title" label="Título"/> 
          </v-col>
          <v-col cols="6" class="_pl-">
            <ColorPickerV2 :colorSelected="selectedSection" type="item-color" title="Cor dos ícones"/>   
          </v-col>
        </v-row>
        <TextField v-model="selectedSection.social.facebook" label="Facebook"/> 
        <TextField v-model="selectedSection.social.instagram" label="Instagram"/> 
        <TextField v-model="selectedSection.social.youtube" label="Youtube"/> 
      </div>
    </form-section>  

    <form-section label="Subtítulo" v-model="isExpanded.subtitle">
      <Texts 
        textType="subtitle" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
        :hide="['content', 'alignment']"
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>

    <form-section label="Texto" v-model="isExpanded.text">
      <Texts 
        textType="text" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
        :hide="['content', 'alignment']"
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg" :divider="false">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        :minValueForNumber="160"
        @update="onUpdateBackground"
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>
  </section>
</template>

<script>
import FormSection from '../../_v2/utils/FormSection.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Background from '../forms/formsV2/Background.vue'
import Alignment from '../forms/formsV2/Alignment.vue'
import Logo from '../forms/formsV2/Logo.vue'
import MenuOptions from '../forms/formsV2/MenuOptions.vue'
import TextField from '../../_v2/ui/TextField.vue'
import MultipleUploadImage from '../../_v2/utils/MultipleUploadImage.vue'
import ColorPickerV2 from '../../_v2/ui/ColorPickerV2.vue'
import isEmpty from './isEmpty.vue'

export default {
  name: 'FooterSection',
  components: { 
    FormSection, 
    Texts, 
    Background, 
    Logo, 
    Alignment, 
    MenuOptions, 
    TextField,
    MultipleUploadImage,
    ColorPickerV2,
    isEmpty
  },  
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  data: () => ({
    isExpanded: {organization: true, contacts: true, social: true, subtitle: true, text: true, bg: true}    
  }),

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    }
  }      
}
</script>